Vue.component('clock', {
    template: `<div class="countdown">
        <div class="hr-line"></div><div class="vr-line"></div><div class="circle"></div>
        <div class="lines">
            <div class="one"></div>
            <div class="two"></div>
            
            <div class="three"></div>
            <div class="four"></div>
            
            <div class="five"></div>
            <div class="six"></div>
            
            <div class="seven"></div>
            <div class="eight"></div>
        </div>
        
        <div class="hand"></div>
    </div>`,

    data () {
        return {
            time: 0
        };
    },

    mounted () {
        // Play sound
        var audio = new Audio('/sounds/countdown.mp3');
        audio.play();

        this.runClock();
    },

    methods: {
        runClock () {
            setTimeout(() => {
                this.time++;

                this.$el.querySelector('.hand').style.transform = 'rotate(' + (this.time * 6) + 'deg)';

                if (this.time < 30) {
                    this.runClock();
                } else {
                    setTimeout(() => {
                        this.$emit('on-timer-end');
                    }, 1000);
                }
            }, 1000);
        }
    }
});